<template>
  <div class="flex flex-col">
    <div class="w-full px-2 mb-6 -mx-2 form-group">
      <input-text-validated
        ref="ambassador.salutation"
        v-model="ambassador.salutation"
        input-class="w-1/2"
        :label="$t('modals.ambassador.form.salutation')"
        :placeholder="$t('modals.ambassador.form.salutationPlaceholder')"
      />
    </div>
    <div class="flex flex-wrap mb-6 -mx-2">
      <div class="w-full px-2 form-group">
        <input-text-validated
          ref="ambassador.name"
          v-model="ambassador.name"
          input-class="w-full"
          :label="$t('modals.ambassador.form.name')"
          :placeholder="$t('modals.ambassador.form.namePlaceholder')"
          rules="required"
        />
      </div>
    </div>

    <div class="flex flex-col w-full mb-6">
      <input-text-validated
        ref="ambassador.role"
        v-model="ambassador.role"
        input-class="w-full"
        :label="$t('modals.ambassador.form.role')"
        :placeholder="$t('modals.ambassador.form.rolePlaceholder')"
        rules="required"
      />
    </div>

    <div class="flex flex-col w-full mb-6">
      <input-text-validated
        ref="ambassador.email"
        v-model="ambassador.email"
        input-class="w-full"
        :label="$t('modals.ambassador.form.email')"
        :placeholder="$t('modals.ambassador.form.emailPlaceholder')"
        rules="required|email"
      />
    </div>

    <div class="flex flex-wrap mb-6 -mx-2">
      <div class="w-1/2 px-2 form-group">
        <input-text-validated
          ref="ambassador.phone"
          v-model="ambassador.phone"
          input-class="w-full"
          :label="$t('modals.ambassador.form.phone')"
          :placeholder="$t('modals.ambassador.form.phonePlaceholder')"
          rules="required|phone"
        />
      </div>

      <div class="w-1/2 px-2 form-group">
        <input-text-validated
          ref="ambassador.mobile"
          v-model="ambassador.mobile"
          input-class="w-full"
          :label="$t('modals.ambassador.form.mobile')"
          :placeholder="$t('modals.ambassador.form.phonePlaceholder')"
          rules="required|phone"
        />
      </div>
    </div>

    <div class="flex flex-col w-full mb-6">
      <input-text-validated
        ref="ambassador.contactSlogan"
        v-model="ambassador.contactSlogan"
        input-class="w-full"
        :label="$t('modals.ambassador.form.contactSlogan')"
        :placeholder="$t('modals.ambassador.form.contactSloganPlaceholder')"
      />
    </div>

    <div class="flex flex-col w-full mb-6">
      <textarea-validated
        ref="ambassador.contactText"
        v-model="ambassador.contactText"
        input-class="w-full"
        :label="$t('modals.ambassador.form.contactText')"
        :placeholder="$t('modals.ambassador.form.contactTextPlaceholder')"
      />
    </div>

    <div class="flex flex-col w-full mb-6">
      <textarea-validated
        ref="ambassador.signature.text"
        v-model="ambassador.signature.text"
        input-class="w-full"
        :label="$t('modals.ambassador.form.emailTextSignature')"
        :placeholder="$t('modals.ambassador.form.emailTextSignaturePlaceholder')"
      />
    </div>

    <div class="flex flex-col w-full mb-6">
      <textarea-validated
        ref="ambassador.signature.html"
        v-model="ambassador.signature.html"
        input-class="w-full"
        :label="$t('modals.ambassador.form.emailHtmlSignature')"
        :placeholder="$t('modals.ambassador.form.emailHtmlSignaturePlaceholder')"
      />
    </div>

    <div class="flex flex-col w-full mb-6">
      <input-file-validated
        ref="ambassador.image.upload"
        v-model="ambassador.image.upload"
        :label="$t('modals.ambassador.form.newImage')"
        accept="image/jpg, image/png"
      />
    </div>
  </div>
</template>

<script>
import InputTextValidated from '@/components/form/text-validated'
import InputFileValidated from '@/components/form/file-validated'
import TextareaValidated from '@/components/form/textarea-validated'
import { faPen } from '@fortawesome/free-solid-svg-icons'

export default {
  components: {
    InputTextValidated,
    InputFileValidated,
    TextareaValidated
  },
  props: {
    ambassador: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      faPen
    }
  }
}
</script>
